export enum PAC_ACCOUNT_TYPE_ENUM {
  POST_ACUTE_FACILITY = 'Post-Acute Facility',
  HOSPITAL_CM_DISCHARGE_PLANNER = 'Hospital Case Manager/Discharge Planner'
}
